import { render, staticRenderFns } from "./PDFMake.vue?vue&type=template&id=5a3509f1&scoped=true&ref=PDFMake"
import script from "./PDFMake.vue?vue&type=script&lang=js"
export * from "./PDFMake.vue?vue&type=script&lang=js"
import style0 from "./PDFMake.vue?vue&type=style&index=0&id=5a3509f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3509f1",
  null
  
)

export default component.exports